import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import dayjs from 'dayjs'
import React from 'react'
import type { LoginHistoryItem } from 'types/login-history'
import { useEditUserDialog } from '../context/EditUserDialogContext'

const UserSessionsView: React.FC = () => {
  const { loginHistory, isLoadingLoginHistory, isLoginHistoryError } = useEditUserDialog()

  if (isLoadingLoginHistory) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    )
  }

  if (isLoginHistoryError) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <Typography color="error" variant="body1">
          Error loading login history. Please try again later.
        </Typography>
      </Box>
    )
  }

  if (!loginHistory || loginHistory.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <Typography color="text.secondary" variant="body1">
          No login history available for this user.
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', maxHeight: '340px' }}>
      <Typography variant="h6" sx={{ mb: 2, flexShrink: 0 }}>
        Login Sessions
      </Typography>
      <TableContainer component={Paper}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>Time</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Device</TableCell>
              <TableCell>IP Address</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loginHistory.map((item: LoginHistoryItem, index: number) => (
              <TableRow key={index} hover>
                <TableCell>{dayjs(item.time).format('MMM D, YYYY h:mm A')}</TableCell>
                <TableCell>
                  <Typography
                    variant="body2"
                    sx={{
                      color: item.action.toLowerCase().includes('login') ? 'success.main' : 'text.primary',
                      fontWeight: 500,
                    }}
                  >
                    {item.action}
                  </Typography>
                </TableCell>
                <TableCell>{item.location || 'Unknown'}</TableCell>
                <TableCell>{item.device || 'Unknown'}</TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
                    {item.ipAddress || 'Unknown'}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default UserSessionsView
